mutation InvoiceSigningAccountingStamper(
  $input: InvoiceSigningAccountingStamperInput!
) {
  invoiceSigningAccountingStamper(input: $input) {
    invoice {
      _accountingStampDate
      _accountingStampUserId
      _accountingStampUserName
      _accountingStampTransactionReference
    }
  }
}
